import { render } from "./MatchingErrorsModal.vue?vue&type=template&id=c90f7524&ts=true&lang=pug"
import script from "./MatchingErrorsModal.vue?vue&type=script&lang=ts"
export * from "./MatchingErrorsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__